import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M2 16v2h20v-2H2zm0-5v2h20v-2H2zm0-5v2h20V6H2z"
}), 'DehazeTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/DehazeTwoTone.js
// module id = 3067
// module chunks = 2